import AppItemType from "./app";

export const webApps: AppItemType[] = [
  {
    title: "AI Fullstack Developer",
    description:
      "Built a full-stack AI-powered networking tool that mapped Gmail contacts, scores relationship health across frequency & surfaces warm into with no manual entry. Added a standalone chat system using zola.chat tool for chat based AI email draft generation which can be sent directly with a single send button. Built a AI pipeline using mastra for automated csv parsing for bulk contacts import at any format",
    company: "Wove",
    location: "United States",
    image: "/wove.svg", // Replace with actual logo path if available
    path: "https://www.linkedin.com/in/sandip-gyawali-615681211/", // Replace with actual URL if available
    tags: [
      "Web Development",
      "AI",
      "NestJs",
      "NextJS",
      "SAAS",
      "NextJS",
      "Mastra"
    ],
  },
  {
    title: "Workshop Mentor",
    description:
      "Mentored participants during a 7-day intensive workshop organized by ASCOL IT Club. Delivered sessions on Web Development titled 'Design to Deployment', guided hands-on projects, provided one-on-one feedback, and helped participants build practical skills. Collaborated with fellow mentors to design an engaging and effective learning experience for 25+ attendees.",
    company: "ASCOL IT Club",
    location: "Kathmandu, Bāgmatī, Nepal",
    image: "/ascol-it-club.jpeg", // Replace with actual logo path if available
    path: "https://www.linkedin.com/in/sandip-gyawali-615681211/", // Replace with actual URL if available
    tags: [
      "Web Development",
      "Mentorship",
      "Team Collaboration",
      "Public Speaking",
      "Design to Deployment",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    title: "Frontend Developer",
    description:
      "A robust hotel management platform built with Next.js, covering POS, inventory, billing, reservations, reports, and dashboards. Migrated from unstable Flutter system to a scalable Next.js stack.",
    company: "Amadico Nepal Pvt. Ltd.",
    location: "Kathmandu, Nepal",
    image: "/amadico.png", // Add logo or relevant image
    path: "https://amadico.com", // Replace with real URL if available
    tags: [
      "Next.js",
      "ShadCN UI",
      "React Query",
      "jsPDF",
      "Zod",
      "React Hook Form",
      "date-fns",
      "React Dropzone",
    ],
  },
  {
    title: "Event Participant",
    description:
      "Participated in the HULT Prize ASCOL 2023-24, Collaborated with a multidisciplinary team to design a smart traffic management solution aimed at reducing urban congestion, lowering emissions, and enhancing commuter safety.",
    company: "Hult Prize at Amrit Science Campus",
    location: "Kathmandu, Nepal",
    image: "/hult.png", // Replace with actual image path if hosted
    path: "https://www.hultprize.org", // Official Hult Prize website
    tags: [
      "Teamwork",
      "Public Speaking",
      "Leadership",
      "Collaboration",
      "Innovation",
    ],
  },
  {
    title: "Full Stack Developer",
    description:
      "Scalable PWA built with Next.js for mock testing, payments, and interviews. Migrated backend from PHP to tRPC for fully type-safe API development.",
    company: "Chhangmi Consultancy Ltd",
    location: "Kathmandu, Nepal",
    image: "/chhangmi.svg", // Add logo or relevant image
    path: "https://chhangmi.edu.np", // Replace with real URL if available
    tags: ["Next.js", "PWA", "tRPC", "TypeScript", "Zod"],
  },
  {
    title: "Frontend Developer",
    description:
      "An advanced admin dashboard with thermal invoice printing, analytics, and real-time updates. Deployed with Nginx + HTTPS and built with performance in mind.",
    company: "Suga360 Pvt. Ltd.",
    location: "LasVegas, Nevada",
    image: "/suga.png", // Add logo or relevant image
    path: "https://suga360.com", // Replace with real URL if available
    tags: [
      "Next.js",
      "Tailwind CSS",
      "Zustand",
      "SWR",
      "RizzUI",
      "Recharts",
      "Embla",
      "jsPDF",
      "Canvas-to-PNG",
      "Nginx",
      "Certbot",
    ],
  },
];
